$.getUserSettings = () => {
    return JSON.parse($.cookie('user_settings') || "{}");
};

$.getUserSetting = (settingName) => {
    return JSON.parse($.cookie('user_settings') || "{}")[settingName];
};

$.setUserSetting = (settingName, value) => {
    var settings = $.getUserSettings();
    settings[settingName] = value;

    $.cookie('user_settings', JSON.stringify(settings), {
        expires: 30,
        path: "/;SameSite=Lax",
    });
};

window.dataLayer = window.dataLayer || [];
function gtag() {
    dataLayer.push(arguments);
}

window.initCookieWindow = (options = {
    googleAnalyticsTrackingId
}) => {
    const updateCookieSettings = () => {
        const cookieWhitelist = $.getUserSetting('cookie_whitelist');

        if (!!cookieWhitelist && !!cookieWhitelist.length) {
            $.each(cookieWhitelist, (i, v) => {
                $(`#cookie-settings-form input[name="${v}"]`).prop('checked', true);
            });
        }
    };

    const updateScripts = () => {
        const cookieWhitelist = $.getUserSetting('cookie_whitelist');

        if (!!cookieWhitelist && !!cookieWhitelist.length) {
            $.each($('script.cookie'), (i, v) => {
                const script = $(v);

                if (cookieWhitelist.includes(script.data('category'))) {
                    script.attr('src', script.data('src'));
                    script.removeAttr('data-src');
                }
            });
        }

        if (!!cookieWhitelist && cookieWhitelist.includes('analytics')) {
            gtag('consent', 'update', {
                'ad_storage': 'granted',
                'analytics_storage': 'granted'
            });
        }
    }

    // prepare cookie window
    if (!$.getUserSetting('cookie_checked')) {
        const cookieWindow = $("#cookie-window");
        const allowAllButton = $("#cookie-allow-btn");
        const disableAllButton = $("#cookie-disable-btn");
        const settingsButton = $("#cookie-settings-btn");
        const cookieTypes = [
            'analytics',
            'functional',
            'targeting'
        ];

        const closeCookieWindow = (cookieWhitelist) => {
            cookieWindow.hide();
            $.setUserSetting('cookie_checked', true);
            $.setUserSetting('cookie_whitelist', cookieWhitelist);
            updateScripts();
        }

        const showCookieSettings = () => {
            $('.cookies__window_settings_wrap').toggle();
            $('.cookies__window_overlay').css('display', 'block');
        };

        const closeCookieSettings = () => {
            $('.cookies__window_settings_wrap').toggle();
            $('.cookies__window_overlay').css('display', 'none');
        };

        updateCookieSettings();

        $('.cookies__window_settings_close').click(() => {
            closeCookieSettings();
        });
        $('.cookies__window_overlay').click(() => {
            closeCookieSettings();
        });
        allowAllButton.click(() => {
            closeCookieWindow(cookieTypes);
        });
        disableAllButton.click(() => {
            closeCookieWindow([]);
        });
        settingsButton.click(() => {
            showCookieSettings();
        });

        $('#cookie-settings-form').submit((e) => {
            e.preventDefault();
            let cookieWhitelist = [];

            $.each($('#cookie-settings-form input[type="checkbox"]'), (i, v) => {
                if (v.checked) {
                    cookieWhitelist.push(v.name);
                }
            });

            closeCookieSettings();
            closeCookieWindow(cookieWhitelist);
        });

        $('#reject-all-cookie-btn').click((e) => {
            e.preventDefault();
            $.each($('#cookie-settings-form input[type="checkbox"]'), (i, v) => {
                $(v).prop('checked', false);
            });

            setTimeout(() => {
                $('#cookie-settings-form').submit();
            }, 500);
        });

        $(".cookies__window_info").click((e) => {
            const target = $(e.target);
            const description = target.parent().siblings('.cookies__window_info_descr');

            if (target.hasClass('is_active')) {
                target.html('+');
                target.removeClass('is_active');
                description.slideUp(300);
            } else {
                $(".cookies__window_info")
                    .removeClass('is_active')
                    .html('+');
                target.addClass('is_active');
                $('.cookies__window_info_descr').slideUp(300);
                description.slideDown(300);
                target.html('-');
            }
        });

        cookieWindow.show();
    }

    // prepare google analytics
    gtag('consent', 'default', {
        'ad_storage': 'denied',
        'analytics_storage': 'denied'
    });
    gtag('js', new Date());
    gtag('config', options.googleAnalyticsTrackingId);

    // enable whitelisted services
    updateScripts();
}
